import MeasurementTable from './MeasurementTable';

export default MeasurementTable;
